import { useQuery } from '@tanstack/react-query';
import { ApiClient } from 'lib/api/client';
import { useStore } from 'lib/store';
import { useApiReady } from './use-api-ready';

type Params = {
  listingId: string;
};

export function useMarketplacePublicListingDetail({ listingId }: Params) {
  const apiReady = useApiReady();
  const activeBuyerOrgId = useStore((store) => store.activeBuyerOrgId);

  return useQuery(
    ['public-listing-detail', listingId],
    () =>
      new ApiClient().marketplacePublicListingApi.marketplaceListingRetrieve({
        listingId: listingId as string,
      }),
    {
      select: (data) => data.data,
      enabled: apiReady && !!activeBuyerOrgId,
      retry: 0,
    }
  );
}
